import type { IResponse } from '@/features/api/extranet'
import { ensureSuccessStatusCode, useFetch } from '@/features/fetch'

export async function loadToken(init?: RequestInit): Promise<string> {
  if (!init) init = { sablier: true, dialogMode: 'retry' }

  const fetch = useFetch('extranet')

  const url = '/administration'

  const response = await fetch(url, init)
  ensureSuccessStatusCode(response)

  const result = (await response.json()) as IResponse<string>

  return result.data
}
